<template>
    <div class="tag-management">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>文章标签管理</span>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            @click="handleAdd"
          >
            添加标签
          </el-button>
        </div>
  
        <!-- 搜索区域 -->
        <div class="search-container">
          <el-input
            v-model="searchQuery"
            placeholder="请输入标签名称"
            style="width: 300px"
            clearable
            @clear="handleSearchClear"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearch"
            />
          </el-input>
        </div>
  
        <!-- 标签表格 -->
        <el-table
          :data="tags"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="id" label="ID" align="center" />
          <el-table-column prop="name" label="标签名称" />
          <el-table-column prop="createdAt" label="创建时间">
            <template slot-scope="scope">
              {{ scope.row.createdAt | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
  
       
      </el-card>
       <!-- 分页 -->
       <div class="pagination-container">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
  
      <!-- 添加/编辑标签对话框 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        :width="dialogWidth"
        @close="resetForm"
      >
        <el-form
          :model="tagForm"
          :rules="rules"
          ref="tagForm"
          label-width="80px"
        >
          <el-form-item label="标签名称" prop="name">
            <el-input v-model="tagForm.name" placeholder="请输入标签名称"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        tags: [], // 标签列表
        filteredTags: [], // 过滤后的标签列表
        loading: false, // 加载状态
        searchQuery: "", // 搜索关键词
        currentPage: 1, // 当前页码
        pageSize: 10, // 每页显示数量
        total: 0, // 总数量
        dialogVisible: false, // 对话框显示状态
        dialogTitle: "添加标签", // 对话框标题
        tagForm: {
          id: "",
          name: "",
        },
        rules: {
          name: [
            { required: true, message: "请输入标签名称", trigger: "blur" },
            { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" },
          ],
        },
        isEdit: false, // 是否是编辑模式
          // 响应式相关数据
   screenWidth: window.innerWidth
      };
    },
    filters: {
      formatDate(value) {
        if (!value) return "";
        const date = new Date(value);
        return date.toLocaleString();
      },
    },
    created() {
      this.fetchTags();
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  computed:{
 // 判断是否为桌面设备
 isDesktop() {
      return this.screenWidth >= 1024;
    },
    // 对话框宽度
    dialogWidth() {
      return this.screenWidth < 768 ? '100%' : '35%';
    },
  },
    methods: {
       // 处理窗口大小变化
     handleResize() {
      this.screenWidth = window.innerWidth;
    },
      // 获取标签列表
      async fetchTags() {
        this.loading = true;
        try {
            const response = await this.$http.get('/api/tags', {
            params: {
                tag: this.searchQuery,
                page: this.currentPage,
                pageSize: this.pageSize
            }
            });
            console.log(response.data.data.list)
            this.tags = response.data.data.list.map(item => ({
            id: item._id, // MongoDB 使用 _id
            name: item.tag, // 对应模型中的 tag 字段
            createdAt: item.createdAt // 如果有的话
            }));
            this.total = response.data.data.total;
        } catch (error) {
            console.error('获取标签列表失败:', error);
            this.$message.error('获取标签列表失败');
        } finally {
            this.loading = false;
        }
        },
      
      // 过滤标签
      filterTags() {
        if (this.searchQuery) {
          this.filteredTags = this.tags.filter(tag => 
            tag.name.toLowerCase().includes(this.searchQuery.toLowerCase())
          );
        } else {
          this.filteredTags = this.tags.slice(
            (this.currentPage - 1) * this.pageSize,
            this.currentPage * this.pageSize
          );
        }
        this.total = this.filteredTags.length;
      },
      
      // 搜索标签
      handleSearch() {
        this.currentPage = 1;
        this.fetchTags();
      },
      
      // 清除搜索
      handleSearchClear() {
        this.searchQuery = "";
        this.fetchTags();
      },
      
      // 每页数量变化
      handleSizeChange(val) {
        this.pageSize = val;
        this.fetchTags();
      },
      
      // 当前页变化
      handleCurrentChange(val) {
        this.currentPage = val;
        this.fetchTags();
      },
      
      // 添加标签
      handleAdd() {
        this.dialogTitle = "添加标签";
        this.isEdit = false;
        this.dialogVisible = true;
      },
      
      // 编辑标签
      handleEdit(index, row) {
        this.dialogTitle = "编辑标签";
        this.isEdit = true;
        this.tagForm = {
          id: row.id,
          name: row.name,
        };
        this.dialogVisible = true;
      },
      
      // 删除标签
      handleDelete(index, row) {
        this.$confirm("此操作将永久删除该标签, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {

            console.log(index,row)
            this.$http.delete(`/api/tags/${row.id}`).then(() => {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.fetchTags();
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
      
      // 提交表单
      async submitForm() {
        this.$refs.tagForm.validate(async valid => {
            if (valid) {
            try {
                if (this.isEdit) {
                // 编辑标签
                await this.$http.put(`/api/tags/${this.tagForm.id}`, {
                    tag: this.tagForm.name // 注意字段名改为 tag
                });
                this.$message.success('修改成功');
                } else {
                // 添加标签
                await this.$http.post('/api/tags', {
                    tag: this.tagForm.name // 注意字段名改为 tag
                });
                this.$message.success('添加成功');
                }
                this.dialogVisible = false;
                this.fetchTags();
            } catch (error) {
                console.error('操作失败:', error);
                this.$message.error(error.response?.data?.message || '操作失败');
            }
            }
        });
        },
      
      // 重置表单
      resetForm() {
        this.tagForm = {
          id: "",
          name: "",
        };
        this.$refs.tagForm.resetFields();
      },
    },
  };
  </script>
  
  <style scoped>
  .tag-management {
    padding: 20px;
  }
  
  .search-container {
    margin-bottom: 20px;
  }
  
  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }
  
  .box-card {
    margin-bottom: 20px;
  }
  </style>